import styled from 'styled-components';

export const MainImg = styled.img`
display: block;
width: 90vw;
margin: auto;
padding: 1rem;
@media screen and (min-width: 916px) {
  width: 38vw;
  padding: 0 1rem;
}
`;